module.exports = __webpack_public_path__ + "f6cba34f3381b44c9045d54bc33e40c9.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/fenugreek.jpg
 ** module id = 449
 ** module chunks = 0
 **/